var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPentool1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3848 84.6153L37.7745 62.2256",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8403 62.2251C49.3436 59.7217 49.3436 55.663 46.8403 53.1597C44.3369 50.6564 40.2782 50.6564 37.7749 53.1597C35.2715 55.663 35.2715 59.7217 37.7749 62.2251C40.2782 64.7284 44.3369 64.7284 46.8403 62.2251Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0002 26.9229L24.3591 37.1793L15.3848 84.6152L62.8207 75.6408L73.0771 49.9998",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2808 12.8217L43.5889 20.5137L79.486 56.4108L87.178 48.7188L51.2808 12.8217Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentool1);
export default __webpack_public_path__ + "static/media/Pen tool 1.986ee1a5b21acfbdd2cebed7a2d9dfca.svg";
export { ForwardRef as ReactComponent };